import { withRouter } from "react-router-dom"

import withPageTitle from "../../routes/containers/withPageTitle"
import Unsubscribe from "../components/unsubscribe/Unsubscribe"

export default withPageTitle("Unsubscribing from Email")(
  withRouter(Unsubscribe)
)
